import { appendAuthTokenToSurveyFileUrl } from "@/lib";

const PRIVATE_EMBED_DOWNLOAD_URL =
  /\/api\/(?:narrative_files|survey_files|idea_files)\/[^/"'>\s]+\/download(?:\?[^"'>\s]*)?/gi;

/**
 * Appends participant access_token to private download URLs embedded in Froala HTML
 * (anonymous / unverified `<img>` requests cannot send x-api-token).
 */
export function signPrivateEmbedHtml(
  html: string | undefined,
  token: string | undefined | null
): string | undefined {
  if (!html || !token) return html;

  return html.replace(PRIVATE_EMBED_DOWNLOAD_URL, (url) => {
    return appendAuthTokenToSurveyFileUrl(url, token) ?? url;
  });
}
